/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of the invitation
 * @export
 */
export const InvitationType = {
    Organization: 'ORGANIZATION',
    PersonalInvitation: 'PERSONAL_INVITATION',
    ShareableLink: 'SHAREABLE_LINK'
} as const;
export type InvitationType = typeof InvitationType[keyof typeof InvitationType];


export function instanceOfInvitationType(value: any): boolean {
    for (const key in InvitationType) {
        if (Object.prototype.hasOwnProperty.call(InvitationType, key)) {
            // @ts-ignore
            if (InvitationType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InvitationTypeFromJSON(json: any): InvitationType {
    return InvitationTypeFromJSONTyped(json, false);
}

export function InvitationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationType {
    return json as InvitationType;
}

export function InvitationTypeToJSON(value?: InvitationType | null): any {
    return value as any;
}

